$(document).ready(function () {
  var valueCared = new Swiper('.value-cards-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: false,
    // speed: 6000,
    // autoplay: {
    //   delay: 1,
    //   disableOnInteraction: false
    // },
    loop: false,
    slidesPerView: 'auto',
    allowTouchMove: false,
    loopedSlides: 10,
    breakpoints: {
      1281: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2
      },
      0: {
        slidesPerView: 1
      }
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
  });
});



/////////////////////////////


$(document).ready(function() {
  $('.faq-question').on('click', function() {
    const $accordion = $(this).closest('.faq-accordion-single');
    const $answer = $accordion.find('.faq-answer');
    const isActive = $accordion.hasClass('active');
    
    // Close all other accordions
    $('.faq-accordion-single').not($accordion).removeClass('active').find('.faq-answer').slideUp();
    
    // Toggle current accordion
    if (isActive) {
      $accordion.removeClass('active');
      $answer.slideUp();
    } else {
      $accordion.addClass('active');
      $answer.slideDown();
    }
  });
});





////////////////////////


$(document).ready(function() {
    var swiper = new Swiper(".swiper-banner-slider", {
        direction: "horizontal",
        effect: "slide",
        autoplay: {
            delay: 6000, 
            disableOnInteraction: false
        },
        parallax: true,
        speed: 1600,
        rtl: true,
        loop: true,
        loopFillGroupWithBlank: !0,
        // mousewheel: {
        //     eventsTarged: ".swiper-slide",
        //     sensitivity: 1
        // },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar"
        }
    });
});


///////////////////////////


gsap.registerPlugin(ScrollTrigger);
const wrappers = document.querySelectorAll('.image-text-custom-row-container');

wrappers.forEach((wrapper, index) => {
  const card = wrapper.querySelector('.image-text-custom-row-flex');
  
  // For the last card, allow normal scroll without pinning.
  if (index === wrappers.length - 1) {
    gsap.set(card, { opacity: 1, scale: 1 });
  } else {
    gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: "top 5%",
        end: "bottom top",
        scrub: true,
        pin: true,
        pinSpacing: false,
      }
    })
    .set(card, { opacity: 1, scale: 1 })
    .to(card, { opacity: 0, scale: 0.6, ease: "none" }, 0.01);
  }
});



////////////////////////////////







/////////////////////////




// Swiper Testimonials

$(document).ready(function () {
  var SwiperTop = new Swiper('.testimonials-upper-slider', {
    slidesPerView: 3.2,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    loop: true,
    loopedSlides: 10,
    breakpoints: {
      1281: {
        slidesPerView: 4.2
      },
      1024: {
        slidesPerView: 3.2
      },
      768: {
        slidesPerView: 2.2
      },
      0: {
        slidesPerView: 1.2
      }
    }
  });

  var SwiperBottom = new Swiper('.testimonials-bottom-slider', {
    slidesPerView: 3.2,
    spaceBetween: 20,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
      reverseDirection: true,
      disableOnInteraction: false
    },
    loop: true,
    loopedSlides: 4,
    slidesPerView: 'auto',
    allowTouchMove: false,
    loop: true,
    loopedSlides: 10,
    breakpoints: {
      1281: {
        slidesPerView: 4.2
      },
      1024: {
        slidesPerView: 3.2
      },
      768: {
        slidesPerView: 2.2
      },
      0: {
        slidesPerView: 1.2
      }
    }
  });
});


// FAQ's

$(".faq-question").on("click", function () {
    var $a_this = $(this), $a_parentCol = $a_this.closest(".faq-accordion-single"),
    $a_allHeadings = $(".faq-question"),
    $a_allLists = $(".faq-answer");
    $a_allHeadings.not($a_this).removeClass("active"),
    $a_this.toggleClass("active"),
    $a_allLists.not($a_parentCol.find(".faq-answer")).slideUp();
    var $a_currentList = $a_parentCol.find(".faq-answer");
    $a_currentList.is(":visible") ? $a_currentList.slideUp() : ($a_allLists.slideUp(), $a_currentList.slideDown()) 
});


///////////////////


//


(function () {
    // small utilities
    function $(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
    function once(fn) { let called = false; return function () { if (called) return; called = true; return fn.apply(this, arguments); }; }
    function debounce(fn, wait = 80) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); }; }
    function buildChevron() {
      const span = document.createElement('span');
      span.className = 'icon icon-chevron-small';
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2.75"></path></svg>';
      return span;
    }
  
    let isConverting = false;
  
    // MAIN: convert Date option groups to select
    function convertDateGroups() {
      if (isConverting) return;
      isConverting = true;
  
      try {
        // find option groups (handles both fieldset and div structures)
        const groups = $( 'fieldset.product-form__input, div.product-form__input' );
  
        groups.forEach(fs => {
          // Skip if this group is currently being interacted with (dropdown open)
          if (fs.querySelector('select:focus')) {
            return;
          }
  
          const legend = fs.querySelector('legend') || fs.querySelector('.form__label');
          if (!legend) return;
          const labelText = (legend.textContent || '').trim().toLowerCase();
          if (!labelText.includes('date')) return;
  
          // If a select already exists for this group, refresh options and skip recreating
          const existing = fs.querySelector('.custom-date-dropdown');
          const radios = $('input[type="radio"]', fs);
          if (!radios.length) {
            // Nothing to convert (maybe theme already renders select) — remove any marker
            if (existing) existing.remove();
            fs.dataset.dateConverted = 'false';
            return;
          }
  
          // If exists -> update options and selection, then return
          if (existing) {
            refreshSelectFromRadios(fs, existing);
            return;
          }
  
          // create new select wrapper
          const wrapper = document.createElement('div');
          wrapper.className = 'select custom-date-dropdown';
          wrapper.style.position = 'relative';
  
          const select = document.createElement('select');
          select.className = 'select__select';
          select.name = radios[0].name || 'option-date';
  
          // populate options from radios
          radios.forEach(r => {
            const opt = document.createElement('option');
            opt.value = r.value;
            opt.textContent = r.value;
            if (r.checked) opt.selected = true;
            select.appendChild(opt);
          });
  
          wrapper.appendChild(select);
          wrapper.appendChild(buildChevron());
  
          // Hide radios + labels visually but keep them in DOM for Shopify listeners
          radios.forEach(r => {
            r.classList.add('js-hide-for-ui');
            r.style.display = 'none';
            const lbl = fs.querySelector(`label[for="${CSS.escape(r.id)}"]`);
            if (lbl) {
              lbl.classList.add('js-hide-for-ui');
              lbl.style.display = 'none';
            }
          });
  
          // insert the wrapper immediately after the legend for correct DOM flow
          legend.insertAdjacentElement('afterend', wrapper);
  
          // sync select -> theme: simulate label click if available; fallback to checking radio + dispatch
          select.addEventListener('change', function () {
            const val = this.value;
            // find radio with same value
            let targetRadio = radios.find(r => r.value === val);
            let targetLabel = null;
            if (targetRadio && targetRadio.id) {
              targetLabel = fs.querySelector(`label[for="${CSS.escape(targetRadio.id)}"]`);
            }
  
            // prefer clicking label (lets theme run its handlers)
            if (targetLabel) {
              // click label to let theme handle selection and URL updates
              targetLabel.click();
            } else if (targetRadio) {
              targetRadio.checked = true;
              targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
  
          // when theme changes radio (e.g., auto-select), keep select in sync
          radios.forEach(r => {
            r.addEventListener('change', function () {
              const checked = fs.querySelector('input[type="radio"]:checked');
              if (checked && wrapper.querySelector('select')) {
                wrapper.querySelector('select').value = checked.value;
              }
            });
          });
  
          // mark processed
          fs.dataset.dateConverted = 'true';
        });
      } finally {
        isConverting = false;
      }
    }
  
    // Refresh existing select options from radios (called when group was re-rendered)
    function refreshSelectFromRadios(fs, wrapper) {
      const select = wrapper.querySelector('select.select__select');
      if (!select) return;
      const radios = $('input[type="radio"]', fs);
      if (!radios.length) return;
  
      const cur = select.value;
      // rebuild options
      select.innerHTML = '';
      radios.forEach(r => {
        const opt = document.createElement('option');
        opt.value = r.value;
        opt.textContent = r.value;
        if (r.checked) opt.selected = true;
        select.appendChild(opt);
      });
  
      // try to preserve previous selection
      if (!select.value && cur) {
        try { select.value = cur; } catch(e) {}
      }
  
      // ensure select change handler is still wired (in case wrapper was preserved)
      select.onchange = function () {
        const val = this.value;
        const targetRadio = radios.find(r => r.value === val);
        if (targetRadio) {
          const lab = fs.querySelector(`label[for="${CSS.escape(targetRadio.id)}"]`);
          if (lab) lab.click();
          else {
            targetRadio.checked = true;
            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };
    }
  
    // Improved debounced rescan with better filtering
    const debouncedConvert = debounce(() => {
      // Don't run if any dropdown is currently focused (being used)
      if (document.querySelector('.custom-date-dropdown select:focus')) {
        return;
      }
      
      // run after paint to avoid flicker
      requestAnimationFrame(() => {
        setTimeout(convertDateGroups, 8);
      });
    }, 150);
  
    // Initial run after full load (images/fonts/layout)
    if (document.readyState === 'complete') {
      // ensure DOM fully ready
      setTimeout(convertDateGroups, 16);
    } else {
      window.addEventListener('load', () => setTimeout(convertDateGroups, 16));
    }
  
    // Listen to Dawn & Shopify events that fire after variant/section updates
    document.addEventListener('product:variant-change', debouncedConvert); // Dawn
    document.addEventListener('variant:change', debouncedConvert);         // some themes
    document.addEventListener('variantchange', debouncedConvert);         // other variations
    document.addEventListener('shopify:section:load', debouncedConvert);
    document.addEventListener('shopify:block:select', debouncedConvert);
  
    // Improved MutationObserver that ignores certain changes
    const productRoot = document.querySelector('main') || document.body;
    if (productRoot) {
      const mo = new MutationObserver((mutations) => {
        // Filter out mutations that are just style/class changes on our dropdowns
        const shouldIgnore = mutations.every(mutation => {
          // Ignore mutations that only affect our custom dropdowns
          if (mutation.type === 'attributes' && 
              mutation.target.classList && 
              (mutation.target.classList.contains('custom-date-dropdown') || 
               mutation.target.classList.contains('select__select'))) {
            return true;
          }
          
          // Ignore mutations that only add/remove our hidden elements
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const removedNodes = Array.from(mutation.removedNodes);
            
            const onlyOurElements = (nodes) => nodes.every(node => 
              node.classList && 
              (node.classList.contains('js-hide-for-ui') || 
               node.classList.contains('custom-date-dropdown'))
            );
            
            if (onlyOurElements(addedNodes) && onlyOurElements(removedNodes)) {
              return true;
            }
          }
          
          return false;
        });
        
        if (!shouldIgnore) {
          debouncedConvert();
        }
      });
      
      mo.observe(productRoot, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  
    // safety: run when window gets focus (useful when returning to tab)
    window.addEventListener('focus', debouncedConvert);
  
    // Prevent conversion when user is interacting with dropdown
    document.addEventListener('focusin', function(e) {
      if (e.target.classList.contains('select__select') && 
          e.target.closest('.custom-date-dropdown')) {
        // Add a class to prevent conversion during interaction
        e.target.closest('fieldset, div').classList.add('dropdown-active');
      }
    });
  
    document.addEventListener('focusout', function(e) {
      if (e.target.classList.contains('select__select') && 
          e.target.closest('.custom-date-dropdown')) {
        // Remove the class after a delay
        setTimeout(() => {
          const group = e.target.closest('fieldset, div');
          if (group) group.classList.remove('dropdown-active');
        }, 100);
      }
    });
})();








////////////////////



$('.featured-product-custom-right fieldset.product-form__input--pill, .main-product-info-right fieldset.product-form__input--pill').each(function() {
  const $labels = $(this).find('label');
  if ($labels.length % 2 !== 0) { // odd number of labels
    $labels.last().css('width', '100%');
  }
});




////////////////////



$(document).ready(function() {
  function checkSingleProductImage() {
    const $sliderSlides = $('.slider__slide');
    const hasSingleImage = $sliderSlides.length === 1;
    
    $sliderSlides.toggleClass('single-image', hasSingleImage);
    
    // Also add class to parent container if needed
    $('.product__media-wrapper, .product__media-list').toggleClass('single-media', hasSingleImage);
  }
  
  // Initial check
  checkSingleProductImage();
  
  // Observer for DOM changes
  const mediaObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length || mutation.removedNodes.length) {
        checkSingleProductImage();
      }
    });
  });
  
  // Observe the product media container
  const mediaContainer = document.querySelector('.product__media-wrapper, .slider');
  if (mediaContainer) {
    mediaObserver.observe(mediaContainer, {
      childList: true,
      subtree: true
    });
  }
  
  // Shopify events
  $(document).on('shopify:section:load shopify:section:unload', checkSingleProductImage);
});



/////////////////////


var pageWidth = $(window).width();
$('.menu-toggle .innerOpnner').on('click', function(e) {
	e.preventDefault();
	$('body').toggleClass('open');
});


(function($) {
    "use strict";
    var app = function() {
        var body = undefined;
        var menu = undefined;
		var menuclick= undefined;
        var menuItems = undefined;
        var init = function init() {
            body = document.querySelector('body');
            menu = document.querySelector('.navOpener');
			menuclick = document.querySelector('.navOpener .innerOpnner');
            menuItems = document.querySelectorAll('.nav__list-item');
            applyListeners();
        };
        var applyListeners = function applyListeners() {
            menuclick.addEventListener('click', function() {
                $('#cursor2').toggleClass('active')
                return toggleClass(body, 'nav-active');
            });
        };
        var toggleClass = function toggleClass(element, stringClass) {
            if (element.classList.contains(stringClass)) element.classList.remove(stringClass);
            else element.classList.add(stringClass);
        };
        init();
    }();

})(jQuery);



///////////////////

$('.product__description_head').click(function () {
  $(this).toggleClass('active');
  $('.product__description_body').slideToggle();
});

$('.prodcut-meta-item-head').click(function () {
  $(this).toggleClass('active');
  $(this).parent('.product-meta-item').find('.product-meta-item-body').slideToggle();
});




//////////////////////////


$(document).ready(function () {
  var partnersSlider = new Swiper('.trusted-partners-slider', {
    slidesPerView: 3,
    spaceBetween: 20,
    centeredSlides: false,
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    loop: true,
    loopedSlides: 10,
    breakpoints: {
      1281: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2.5
      },
      0: {
        slidesPerView: 2.8
      }
    }
  });
});



///////////////////////////


$('.dropdown-mobile-arrow').on('click', function () {
    $('.dropdown').removeClass('dropdown-active');    
    $(this).parent().find('.dropdown').addClass('dropdown-active');
});

$('.dropdown-back-arrow').on('click', function () {
    $('.dropdown').removeClass('dropdown-active');
});

$('.grand-dropdown-mobile-arrow').on('click', function () {
    $('.grandmenu').removeClass('dropdown-active');    
    $(this).parent().find('.grandmenu').addClass('dropdown-active');
});

$('.grandmenu-back-arrow').on('click', function () {
    $('.grandmenu').removeClass('dropdown-active');
});

/////////////////////////// 


// parallax
// https://github.com/yitengjun/ukiyo-js
const els = document.querySelectorAll(".ukiyo");
els.forEach((el) => {
  const parallax = new Ukiyo(el);
});

// smooth scroll
const lenis = new Lenis({
  lerp: 0.1,
  smooth: true,
  direction: "vertical"
});

function raf() {
  lenis.raf();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);





///////////////////////////